module.exports = __webpack_public_path__ + "static/media/leb4.c917113d.avif";